import type { SynchronizedWith } from '@openx/types/deal.ts';
import type { DealDetailsSectionProps } from '../../types.ts';
import { TddSyncErrorsSection } from './sections/TddSyncErrorsSection.tsx';
import { TddSyncStatusesSection } from './sections/TddSyncStatusesSection.tsx';

export type DealTDD = {
  synchronized_with: Required<Pick<SynchronizedWith, 'pdp_sync'>>;
};

export const DealTddSyncTab = <T extends DealTDD = DealTDD>({ deal }: DealDetailsSectionProps<T>) => {
  return (
    <>
      <TddSyncStatusesSection pdpSync={deal.synchronized_with.pdp_sync} />
      <TddSyncErrorsSection
        pdpLastSyncError={deal.synchronized_with.pdp_sync.pdp_last_sync_error}
        syncStatus={deal.synchronized_with.pdp_sync.pdp_sync_status}
      />
    </>
  );
};
